// extracted by mini-css-extract-plugin
export default {"selectPartner":"selectPartner_selectPartner__mrKj7","partner":"selectPartner_partner__lpr3S","info":"selectPartner_info__ktZ+1"};